import { Typography } from "@mui/material";

import { useMediaQueryBreakpoint } from "@hooks/useMediaQueryBreakpoint";
import LinkedIn from "@public/about_us/linked_in.svg";
import LinkedInSmall from "@public/about_us/linked_in_small.svg";

import {
  LinkedInBtn,
  WorkerInfoContainer,
  WorkerInfoTextContainer,
} from "./styles.styled";

export interface WorkerInfoProps {
  infoTitle: string;
  infoText: string;
  infoLink: string;
}

export const WorkerInfo = ({
  infoTitle,
  infoText,
  infoLink,
}: WorkerInfoProps) => {
  const { isDesktopXl, isDesktop } = useMediaQueryBreakpoint();

  return (
    <WorkerInfoContainer className="fire-hover">
      {isDesktop && (
        <WorkerInfoTextContainer>
          <Typography
            variant={
              isDesktopXl
                ? "paragraph_medium_semibold"
                : isDesktop
                  ? "paragraph_small_semibold"
                  : "paragraph_xsmall_semibold"
            }
            align="left"
          >
            {infoTitle}
          </Typography>

          <Typography
            variant={
              isDesktopXl
                ? "paragraph_medium_regular"
                : isDesktop
                  ? "paragraph_small_regular"
                  : "paragraph_xsmall_regular"
            }
            align="left"
          >
            {infoText}
          </Typography>
        </WorkerInfoTextContainer>
      )}

      <LinkedInBtn
        variant="contained"
        disableElevation
        className="self-end"
        href={infoLink}
        target="_blank"
      >
        {isDesktop ? <LinkedIn /> : <LinkedInSmall />}
      </LinkedInBtn>
    </WorkerInfoContainer>
  );
};
